import { useEffect, useRef, useState } from 'react';

const email = 'pleasantplaygroundgarden@gmail.com';
const googleFormBaseUrl =
  'https://docs.google.com/forms/d/19vxLggbNG7rZXPlUSS8bMjYWK6rYwqz4NUEEfaLxIl8/viewform';
const googleFormEmbedUrl = `${googleFormBaseUrl}?embedded=true`;

function Apply() {
  const [loading, setLoading] = useState(true);
  const [iframeFailed, setIframeFailed] = useState(false);
  const timeoutRef = useRef(null);
  const hasLoadedRef = useRef(false);

  useEffect(() => {
    timeoutRef.current = setTimeout(() => {
      if (!hasLoadedRef.current) {
        setIframeFailed(true);
        setLoading(false);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }, 10000);

    return () => clearTimeout(timeoutRef.current);
  }, []);

  const handleIframeLoad = () => {
    hasLoadedRef.current = true;
    setLoading(false);
    clearTimeout(timeoutRef.current);
  };

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div className="min-h-screen bg-[#f8f4ea] text-[#18271e]">
      <section className="border-b border-[#d8d0be] bg-[#fbf8ef]">
        <div className="mx-auto max-w-[92rem] px-6 py-14 sm:px-10 md:py-20 lg:px-16">
          <h1 className="font-serif text-5xl font-normal leading-tight text-[#0c351e] sm:text-6xl">
            Join the Garden
          </h1>
          <div className="mt-5 h-px w-24 bg-[#304536]" />
          <p className="font-handwritten mt-5 max-w-xl text-xl leading-snug text-[#243c2c] sm:text-2xl">
            Fill out the form below to connect with Pleasant Playground Community Garden.
          </p>
        </div>
      </section>

      <section className="bg-[#f8f4ea] px-4 py-8 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-5xl">
          {iframeFailed && (
            <div className="mb-6 border border-[#b84b3c] bg-[#f7d8d3] px-6 py-5 text-center text-[#7d2e23] shadow-sm">
              <p className="mb-1 text-xl font-semibold">Sorry, the form is having trouble loading.</p>
              <p>
                You can reach us directly at{' '}
                <a href={`mailto:${email}`} className="font-medium underline underline-offset-4">
                  {email}
                </a>
                .
              </p>
              <button
                onClick={handleReload}
                className="mt-4 border border-[#10351f] bg-[#10351f] px-5 py-2 font-medium text-[#fbf8ef] transition-colors hover:bg-[#0a2416]"
                type="button"
              >
                Try Again
              </button>
            </div>
          )}

          <div className="mb-6 bg-white px-4 py-3 text-center text-sm text-[#445044] shadow-sm">
            If the form does not load, you can{' '}
            <a
              href={googleFormBaseUrl}
              target="_blank"
              rel="noreferrer"
              className="font-medium text-[#10351f] underline decoration-[#cfc7b6] underline-offset-4 hover:text-[#8e3a2b]"
            >
              open it in a new tab
            </a>
            .
          </div>

          <div className="relative min-h-[854px]">
            <div
              className={`absolute left-1/2 top-28 z-10 -translate-x-1/2 transition-opacity duration-700 ${
                loading && !iframeFailed ? 'opacity-100' : 'pointer-events-none opacity-0'
              }`}
            >
              <div className="h-14 w-14 animate-spin rounded-full border-4 border-[#d8d0be] border-l-[#10351f]" />
            </div>

            {!iframeFailed && (
              <iframe
                src={googleFormEmbedUrl}
                title="Pleasant Playground Community Garden join form"
                frameBorder="0"
                marginHeight="0"
                marginWidth="0"
                onLoad={handleIframeLoad}
                loading="lazy"
                className={`h-[854px] w-full transition-opacity duration-700 ${
                  loading ? 'opacity-0' : 'opacity-100'
                }`}
              >
                Loading...
              </iframe>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Apply;
